/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Errors_Failedtodelete2Inputs */

const he_posts_errors_failedtodelete2 = /** @type {(inputs: Posts_Errors_Failedtodelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיקת הפוסט נכשלה`)
};

const en_posts_errors_failedtodelete2 = /** @type {(inputs: Posts_Errors_Failedtodelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete post`)
};

/**
* | output |
* | --- |
* | "Failed to delete post" |
*
* @param {Posts_Errors_Failedtodelete2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_errors_failedtodelete2 = /** @type {((inputs?: Posts_Errors_Failedtodelete2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Errors_Failedtodelete2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_errors_failedtodelete2(inputs)
	return en_posts_errors_failedtodelete2(inputs)
});
export { posts_errors_failedtodelete2 as "posts_errors_failedToDelete" }